import { useSelector } from 'react-redux';
import { ReduxStore } from 'store';

export function useAuth() {
  return useSelector((state: ReduxStore) => state.auth) as ReduxStore['auth'];
}

export default useAuth;
